import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.PieSentimentView extends Monitoring.Reports.Executive.AbstractSectionView
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  pieTemplate: JST["backbone/templates/monitoring/reports/executive/sentiment_pie"]
  tagName: 'section'
  id: 'brand-sentiment'
  chartClass: 'sentiment-pie-container'
  icon: 'pie'

  initialize: (@options = {}) ->
    @colors = @options.colors

  render: ->
    @bindChartsReady(1)
    @$el.html(@genericTemplate(self: this))
    @$el.find('.chart_container').html(@pieTemplate())
    @addSentimentPie('.sentiment-pie')
    return this

  addSentimentPie: (divId, type=false)->
    query = @accountSentimentQuery()
    query.type = type if type
    @_addPie(_.extend({}, query, @getExtraQuery()), divId, { callback: @updatePercentage } )

  updatePercentage: (response, divId) =>
    values = {}
    for point in response.series[0].data
      values[point.code] = point.y
    total = values.negative + values.neutral + values.positive

    positive_percentage = @_percentage(values.positive, total)
    @$el.find('.pos').find('.percentage-positive').text(positive_percentage)

    neutral_percentage = @_percentage(values.neutral, total)
    @$el.find('.neutral').find('.percentage-neutral').text(neutral_percentage)

    negative_percentage = @_percentage(values.negative, total)
    @$el.find('.neg').find('.percentage-negative').text(negative_percentage)
